import { Typography } from '@mui/material';
import React from 'react';
import HdButton from '../../../../../button/components/button/HdButton';
import { DESTINATION_TYPES } from '../../../constants/destinationTypes';
import HdDocLink from '../../../../../docs/components/doc-link/HdDocLink';
import HdIcon from '../../../../../media/components/icon/HdIcon';
import styles from './AddManagedWarehouseBanner.module.scss';

interface ManagedWarehouseProps {
  type: string;
  actionHandler: Function;
}

export default function AddManagedWarehouseBanner({ type, actionHandler }: ManagedWarehouseProps) {
  return (
    <div className={`header-container ${styles.headerWrapper}`}>
      <div className={styles.noticeBadge}>
        <HdIcon name='help' size={3} className='text-info mr-2' />

        <Typography component='span' className={styles.linkHolder}>
          <b>Don't have a {type}?</b> Don't worry, we will set up a BigQuery {type} for you.{' '}
          <HdDocLink
            docLink={DESTINATION_TYPES.MANAGED_BIGQUERY.docLink}
            section='select_destination_type'
            label='What is BigQuery'
            dataId='managed-warehouse-bigquery'
          />
        </Typography>

        <HdButton onClick={actionHandler} dataId='managed-warehouse-setup'>
          Set Up Destination
        </HdButton>
      </div>

      <div className={styles.orHolder}>
        <div className={styles.divider} />
        <div className={styles.text}>OR</div>
        <div className={styles.divider} />
      </div>

      <Typography variant='subtitle2' component='h4'>
        Select the type of Destination you have below
      </Typography>
    </div>
  );
}
